import React, { Component } from 'react';
import { Gift } from 'lucide-react';
const bonuses = [{
  title: 'Bono 1 — Directorio de Herramientas Esenciales',
  description: 'Lista completa con fotos y especificaciones de cada herramienta que necesitás para reparar scooters. Sabés exactamente qué comprar y dónde, sin gastar de más en herramientas que no vas a usar.'
}, {
  title: 'Bono 2 — Guía Visual de Partes y Componentes',
  description: 'Mapa visual de cada componente del scooter con nombres técnicos, función y proveedores. Identificás piezas al instante y hablás el idioma de los técnicos profesionales.'
}, {
  title: 'Bono 3 — Checklist de Inspección Pre-Viaje',
  description: 'Lista rápida de 12 puntos para revisar antes de cada viaje. Detectás fallas críticas en 60 segundos y rodás siempre con la tranquilidad de un scooter seguro.'
}, {
  title: 'Bono 4 — Protocolo Anti-Frustración del Reparador',
  description: 'Sistema para resolver reparaciones complejas sin perder la paciencia. Estrategias mentales y de organización para reparadores que enfrentan casos difíciles.'
}, {
  title: 'Bono 5 — Script de Cobro y Gestión de Clientes',
  description: 'Exactamente qué decir y cómo decirlo para cobrar tus servicios de reparación sin conflictos. Incluye modelos de mensajes para WhatsApp, políticas de garantía y protocolo de baja por morosidad.'
}, {
  title: 'Bono 6 — Pack de 20 Plantillas de Instagram para Talleres',
  description: 'Plantillas editables en Canva para publicar contenido de autoridad en redes sociales. Diseñadas para posicionarte como referente y atraer clientes a tu taller sin saber de diseño ni marketing.'
}];
export function Bonuses() {
  return <section className="py-12 md:py-20 px-4 sm:px-6 lg:px-8 bg-zinc-950 relative overflow-hidden" data-id="element-18">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1200px] h-[600px] bg-[#ff2e92] opacity-5 rounded-full blur-[150px] pointer-events-none" data-id="element-19"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-20">
        <div className="text-center mb-8 md:mb-12" data-id="element-21">
          <div className="inline-flex items-center gap-2 md:gap-3 px-4 md:px-8 py-2 md:py-4 rounded-full bg-gradient-to-r from-[#ff2e92]/20 to-[#00b8ff]/20 border-2 border-[#ff2e92]/50 text-white font-bold text-sm md:text-2xl mb-6 md:mb-8 animate-pulse" data-id="element-22">
            <Gift className="text-[#ff2e92] w-5 h-5 md:w-8 md:h-8" data-id="element-23" />
            <span data-id="element-24">GRATIS POR EL DÍA DE HOY</span>
            <Gift className="text-[#00b8ff] w-5 h-5 md:w-8 md:h-8" data-id="element-25" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold mb-4 md:mb-6" data-id="element-26">
            Bonos Exclusivos
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-4 md:gap-6 mb-8 md:mb-12" data-id="element-27">
          {bonuses.map((bonus, i) => <div key={i} className="bg-zinc-900/80 p-4 md:p-6 rounded-xl border border-zinc-800 hover:border-[#00b8ff]/50 transition-colors" data-id="element-28">
              <div className="flex items-start gap-3 md:gap-4" data-id="element-29">
                <div className="bg-[#ff2e92]/10 p-2 md:p-3 rounded-lg shrink-0" data-id="element-30">
                  <Gift className="w-5 h-5 md:w-6 md:h-6 text-[#ff2e92]" data-id="element-31" />
                </div>
                <div data-id="element-32">
                  <h3 className="text-base md:text-xl font-bold text-white mb-1 md:mb-2" data-id="element-33">
                    {bonus.title}
                  </h3>
                  <p className="text-sm md:text-base text-zinc-400" data-id="element-34">
                    {bonus.description}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        <div className="text-center space-y-2 md:space-y-4" data-id="element-35">
          <p className="text-lg md:text-2xl text-zinc-400" data-id="element-36">
            Valor total de los 6 bonos:{' '}
            <span className="line-through text-zinc-600" data-id="element-37">$84.000 ARS</span>
          </p>
          <p className="text-2xl md:text-3xl font-bold text-[#00b8ff]" data-id="element-38">
            Por el día de hoy → GRATIS ✅
          </p>
        </div>
      </div>
    </section>;
}